import React from 'react';
import { PayloadAction } from '@reduxjs/toolkit';
import MyWorker from './csv.worker';
import { loaded, missingColumns, success } from './csv-worker.slice';
import { FileDetails } from '../../Uploader/context';

type Args = {
    onValidateHeaders: (a: string) => void;
    onSuccess: (a: { fileDetails: Partial<FileDetails>; workSheet: any; errors: any[] }) => void;
    workerId: number;
};

/**
 *
 * @param args.onValidateHeaders - must be memoized function
 * @param args.onSuccess -  must be memoized function
 * @param args.workerId - must be a number (allows rerendering of the worker/termination)
 * @returns
 */
function useCsvWorker(args: Args) {
    const { onValidateHeaders, onSuccess, workerId } = args;
    // we don't want to create a brand new worker on every render
    // so we will expect the caller to tell us when they want a new worker
    // const workerRef = React.useRef<Worker | null>();
    const [worker, setWorker] = React.useState<Worker | null>(() => new MyWorker());

    React.useEffect(() => {
        setWorker(new MyWorker());
    }, [workerId]);

    React.useEffect(() => {
        const listener = (event: MessageEvent) => {
            const { type, payload } = event?.data as PayloadAction<any>;

            switch (type) {
                case `${loaded}`:
                    break;
                case `${missingColumns}`:
                    onValidateHeaders(payload);
                    break;
                case `${success}`:
                    onSuccess(payload);
                    break;
                default:
                    break;
            }
        };

        worker?.addEventListener?.('message', listener);

        return () => {
            worker?.removeEventListener('message', listener);
            // kill the worker in case we haven't already so we don't have a memory leak
            worker?.terminate();
        };
    }, [onValidateHeaders, onSuccess, worker]);

    return worker;
}

export default useCsvWorker;
